var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"card-default"},[_c('v-card-title',{staticClass:"card-title text--primary mb-0 pb-0"},[_vm._v(" Keogram ")]),_c('v-card-text',{staticClass:"card-text text--primary"},[_c('v-img',{attrs:{"src":_vm.propsKeo}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }